import React from 'react';
import ReactDOM from 'react-dom/client';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './styles/variables.css';
import './styles/globals.css';
import './styles/components.css';
import './components/ui/Toast.css';
import './components/ui/Skeleton.css';
import './components/ui/LazyImage.css';
import './components/sections/Portfolio.css';
import './components/sections/Testimonials.css';
import './components/sections/Process.css';
import './components/sections/DarkSection.css';
import './pages/Legal.css';
import App from './App';
import { registerServiceWorker } from './utils/registerServiceWorker';
import { initFocusVisible } from './utils/accessibility';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Initialize AOS (Animate On Scroll)
AOS.init({
  offset: 0,
  duration: 800,
  once: true,
  easing: 'ease-out-cubic'
});

// Register Service Worker for PWA
registerServiceWorker();

// Initialize accessibility features
initFocusVisible();
